<template>
  <div class="login-page">
    <div class="login-page__aurora"></div>
    <div class="login-page__grid"></div>
    <div class="login-page__beam login-page__beam--left"></div>
    <div class="login-page__beam login-page__beam--right"></div>
    <div class="login-page__particles">
      <span v-for="item in particles" :key="item.id" class="login-page__particle" :style="item.style"></span>
    </div>
    <div class="login-page__orb login-page__orb--left"></div>
    <div class="login-page__orb login-page__orb--right"></div>
    <div class="login-page__scan"></div>

    <div class="login-page__panel">
      <!-- 左侧品牌区 -->
      <section class="login-hero">
        <div class="login-hero__badge">
          <span></span>
          PK ANSWER MANAGEMENT PLATFORM
        </div>
        <h1>政企PK<br>答题管理</h1>
        <p>
          集中管理题库、试卷与 PK 对战规则，让答题运营在一个清晰的数字界面里高效运转。
        </p>
        <div class="login-hero__metrics">
          <!-- <div v-for="item in heroMetrics" :key="item.label" class="login-hero__metric">
            <strong>{{ item.value }}</strong>
            <span>{{ item.label }}</span>
          </div> -->
        </div>
      </section>

      <!-- 右侧登录卡片 -->
      <section class="login-card">
        <div class="login-card__glow"></div>
        <div class="login-card__title-block">
          <div class="login-card__eyebrow">SECURE ACCESS</div>
          <h2>账号登录</h2>
        </div>
        <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @submit.native.prevent>
          <el-form-item label="手机号" prop="zauPhone">
            <el-input v-model.trim="form.zauPhone" prefix-icon="el-icon-user" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="zauPw">
            <el-input v-model.trim="form.zauPw" prefix-icon="el-icon-lock" type="password" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-button type="primary" :loading="submitting" class="login-page__submit" @click="handleLogin">
            进入系统
          </el-button>
        </el-form>
        <div class="login-card__footer">
          <span></span>
          题库 / 试卷 / PK
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getZqpkAuthUserProjectList } from '@/api/api'
import { setLoginPw } from '@/utils/auth'

export default {
  name: 'LoginPage',
  data () {
    return {
      submitting: false,
      form: {
        zauPhone: '',
        zauPw: ''
      },
      heroMetrics: [
        { value: '01', label: '题库管理' },
        { value: '24h', label: '实时运营' },
        { value: '100%', label: '答题竞赛' }
      ],
      particles: [
        { id: 1, style: { left: '10%', top: '22%', animationDelay: '0s', animationDuration: '9s' } },
        { id: 2, style: { left: '22%', top: '68%', animationDelay: '1.2s', animationDuration: '11s' } },
        { id: 3, style: { left: '38%', top: '16%', animationDelay: '2.1s', animationDuration: '10s' } },
        { id: 4, style: { left: '58%', top: '76%', animationDelay: '0.8s', animationDuration: '12s' } },
        { id: 5, style: { left: '72%', top: '24%', animationDelay: '1.8s', animationDuration: '9.5s' } },
        { id: 6, style: { left: '86%', top: '58%', animationDelay: '2.6s', animationDuration: '11.5s' } }
      ],
      rules: {
        zauPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        zauPw: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          // 首次登录（不传 projectId），拿到默认凭证
          await this.$store.dispatch('user/login', this.form)
          // 暂存明文密码到 sessionStorage，供首页"切换项目"重新登录换取项目凭证
          setLoginPw(this.form.zauPw)
          await this.afterLogin()
        } catch (error) {
          // 错误提示已在请求层处理
        } finally {
          this.submitting = false
        }
      })
    },
    // 登录成功后：获取关联项目列表，单项目直接进入，多项目跳转项目选择页
    async afterLogin () {
      const res = await getZqpkAuthUserProjectList({ currentPage: 1, pageSize: 999 })
      const projects = res.data || []
      if (projects.length === 0) {
        this.$message.warning('当前账号未关联任何项目，请联系管理员')
        this.$store.dispatch('user/logout')
        return
      }
      if (projects.length === 1) {
        // 单项目：当前凭证已是该项目，直接进入首页
        this.enterHome()
        return
      }
      // 多项目：跳转到项目选择页
      this.$router.replace('/project-select')
    },
    enterHome () {
      this.$router.replace('/loading')
      this.$message.success('登录成功，正在进入工作台')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px 28px;
  background:
    radial-gradient(circle at 14% 18%, rgba(26, 54, 93, 0.22), transparent 24%),
    radial-gradient(circle at 88% 16%, rgba(56, 161, 105, 0.18), transparent 20%),
    radial-gradient(circle at 50% 110%, rgba(26, 54, 93, 0.12), transparent 28%),
    linear-gradient(135deg, #f8fbfd 0%, #edf4f8 42%, #e6f0f4 100%);
}

.login-page__aurora, .login-page__grid, .login-page__scan, .login-page__orb, .login-page__beam, .login-page__particles {
  position: absolute; pointer-events: none;
}

.login-page__aurora {
  inset: -12% -10% auto; height: 420px;
  background:
    radial-gradient(circle at 18% 40%, rgba(26, 54, 93, 0.18), transparent 32%),
    radial-gradient(circle at 50% 12%, rgba(255, 255, 255, 0.7), transparent 28%),
    radial-gradient(circle at 82% 30%, rgba(56, 161, 105, 0.16), transparent 30%);
  filter: blur(14px); opacity: 0.95;
}

.login-page__grid {
  inset: 0;
  background-image:
    linear-gradient(rgba(26, 54, 93, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(26, 54, 93, 0.05) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(circle at center, #000 42%, transparent 86%);
  opacity: 0.8;
}

.login-page__beam {
  position: absolute; width: 38vw; max-width: 520px; min-width: 260px; height: 180px;
  border-radius: 999px; filter: blur(12px); opacity: 0.5; transform: rotate(-18deg);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0));
}

.login-page__beam--left { left: -6%; top: 18%; animation: beamFloatLeft 14s ease-in-out infinite; }
.login-page__beam--right { right: -8%; bottom: 14%; transform: rotate(18deg); animation: beamFloatRight 16s ease-in-out infinite; }

.login-page__particles { inset: 0; }
.login-page__particle {
  position: absolute; width: 8px; height: 8px; border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.95), rgba(56, 161, 105, 0.3) 62%, rgba(56, 161, 105, 0));
  box-shadow: 0 0 18px rgba(56, 161, 105, 0.24);
  animation: particleFloat linear infinite;
}

.login-page__scan {
  inset: -30% 0 auto; height: 240px;
  background: linear-gradient(180deg, rgba(26, 54, 93, 0), rgba(26, 54, 93, 0.08), rgba(26, 54, 93, 0));
  animation: scanMove 8s linear infinite;
}

.login-page__orb { border-radius: 50%; filter: blur(12px); }
.login-page__orb--left { width: 320px; height: 320px; left: -80px; top: 90px; background: radial-gradient(circle, rgba(26, 54, 93, 0.22), transparent 68%); }
.login-page__orb--right { width: 280px; height: 280px; right: -30px; bottom: 40px; background: radial-gradient(circle, rgba(56, 161, 105, 0.18), transparent 70%); }

.login-page__panel {
  position: relative; z-index: 1; width: min(1240px, 100%);
  display: grid; grid-template-columns: minmax(0, 1.2fr) 430px; gap: 38px; align-items: center;
}

.login-hero { padding: 52px 0 52px 28px; color: #35506c; }

.login-hero__badge {
  width: fit-content; display: inline-flex; align-items: center; gap: 10px;
  padding: 10px 16px; border: 1px solid rgba(26, 54, 93, 0.16); border-radius: 999px;
  background: rgba(255, 255, 255, 0.62); box-shadow: 0 12px 32px rgba(26, 54, 93, 0.08);
  color: #42617f; font-size: 12px; letter-spacing: 0.16em;
}

.login-hero__badge span { width: 8px; height: 8px; border-radius: 50%; background: #38a169; box-shadow: 0 0 16px rgba(56, 161, 105, 0.58); }

.login-hero h1 { margin: 28px 0 0; font-size: 58px; line-height: 1.08; letter-spacing: 0.03em; color: #243447; text-shadow: 0 10px 30px rgba(26, 54, 93, 0.1); }
.login-hero p { margin: 24px 0 0; max-width: 580px; font-size: 16px; line-height: 1.95; color: rgba(53, 80, 108, 0.76); }

.login-hero__metrics { margin-top: 42px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; max-width: 720px; }

.login-hero__metric {
  position: relative; padding: 20px 20px 18px;
  border: 1px solid rgba(117, 145, 173, 0.16); border-radius: 20px;
  background: rgba(255, 255, 255, 0.66); box-shadow: 0 14px 36px rgba(38, 64, 92, 0.08);
  backdrop-filter: blur(14px);
}

.login-hero__metric::after {
  content: ''; position: absolute; left: 18px; right: 18px; top: 0; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(26, 54, 93, 0.4), transparent);
}

.login-hero__metric strong { display: block; font-size: 28px; font-weight: 700; color: #1a365d; }
.login-hero__metric span { display: block; margin-top: 10px; font-size: 13px; letter-spacing: 0.08em; color: rgba(53, 80, 108, 0.68); }

.login-card {
  position: relative; overflow: hidden; padding: 34px 30px 28px;
  border: 1px solid rgba(117, 145, 173, 0.18); border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.78));
  box-shadow: 0 30px 70px rgba(38, 64, 92, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(18px);
}

.login-card::before {
  content: ''; position: absolute; inset: 0; border-radius: inherit; padding: 1px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(26, 54, 93, 0.18), rgba(56, 161, 105, 0.14));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none;
}

.login-card__glow {
  position: absolute; width: 240px; height: 240px; right: -100px; top: -90px; border-radius: 50%;
  background: radial-gradient(circle, rgba(26, 54, 93, 0.22), transparent 72%);
}

.login-card__glow::after {
  content: ''; position: absolute; width: 170px; height: 170px; right: 42px; top: 54px; border-radius: 50%;
  background: radial-gradient(circle, rgba(56, 161, 105, 0.18), transparent 74%);
}

.login-card__title-block { position: relative; z-index: 1; }
.login-card__eyebrow { color: #38a169; font-size: 12px; letter-spacing: 0.18em; }
.login-card__title-block h2 { margin: 14px 0 0; font-size: 32px; color: #243447; }
.login-card__title-block p { margin: 10px 0 28px; font-size: 14px; line-height: 1.8; color: rgba(53, 80, 108, 0.72); }

.login-page ::v-deep .el-form-item__label { color: #3e5873; }
.login-page ::v-deep .el-input__inner { height: 48px; border: 1px solid rgba(117, 145, 173, 0.22); background: rgba(255, 255, 255, 0.86); color: #243447; box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72); }
.login-page ::v-deep .el-input__inner:focus { border-color: rgba(26, 54, 93, 0.58); box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.09); }
.login-page ::v-deep .el-input__prefix, .login-page ::v-deep .el-input__suffix { color: rgba(26, 54, 93, 0.58); }

.login-page__submit {
  position: relative; z-index: 1; width: 100%; margin-top: 10px; height: 48px;
  border: none; border-radius: 14px;
  background: linear-gradient(90deg, #1a365d 0%, #38a169 100%);
  box-shadow: 0 16px 30px rgba(26, 54, 93, 0.2); overflow: hidden;
}

.login-page__submit::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(110deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.34), rgba(255, 255, 255, 0));
  transform: translateX(-130%); transition: transform 0.5s ease;
}

.login-page__submit:hover::after, .login-page__submit:focus::after { transform: translateX(130%); }
.login-page__submit:hover, .login-page__submit:focus { transform: translateY(-1px); box-shadow: 0 22px 38px rgba(26, 54, 93, 0.24); }

.login-card__footer {
  position: relative; z-index: 1; margin-top: 24px;
  display: flex; align-items: center; gap: 12px;
  color: rgba(53, 80, 108, 0.6); font-size: 12px; letter-spacing: 0.12em;
}

.login-card__footer span { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(26, 54, 93, 0.36), transparent); }

@keyframes scanMove { 0% { transform: translateY(-10%); } 100% { transform: translateY(120vh); } }
@keyframes beamFloatLeft { 0%, 100% { transform: rotate(-18deg) translate3d(0, 0, 0); } 50% { transform: rotate(-14deg) translate3d(26px, 24px, 0); } }
@keyframes beamFloatRight { 0%, 100% { transform: rotate(18deg) translate3d(0, 0, 0); } 50% { transform: rotate(22deg) translate3d(-24px, -22px, 0); } }
@keyframes particleFloat { 0% { transform: translate3d(0, 0, 0) scale(0.92); opacity: 0.22; } 35% { opacity: 0.76; } 100% { transform: translate3d(0, -34px, 0) scale(1.08); opacity: 0.08; } }

@media screen and (max-width: 1080px) { .login-page__panel { grid-template-columns: 1fr; } .login-hero { padding: 12px 0 0; } }
@media screen and (max-width: 768px) {
  .login-page { padding: 20px 16px; }
  .login-hero h1 { font-size: 42px; }
  .login-hero__metrics { grid-template-columns: 1fr; }
  .login-card { padding: 24px 20px; }
}
</style>
